@if (speechAvailable()) {
  <div
    #toolbar
    class="sentence-speech"
    role="toolbar"
    [attr.aria-label]="'QUESTIONS.PRONUNCIATION.LISTEN.TOOLBAR' | translate"
  >
    <button
      nrTourAnchor="sentence"
      type="button"
      class="sentence-speech__listen"
      [id]="listenId"
      data-speech-item
      [class.playing]="isSentencePlaying()"
      [disabled]="disabled()"
      [attr.tabindex]="activeItemIndex() === sentenceItemIndex ? 0 : -1"
      [attr.aria-label]="
        (isSentencePlaying()
          ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
          : 'QUESTIONS.PRONUNCIATION.LISTEN.SENTENCE'
        ) | translate
      "
      (focus)="activeItemIndex.set(sentenceItemIndex)"
      (click)="toggleSentence()"
    >
      <odl-icon aria-hidden="true" [name]="isSentencePlaying() ? 'pause' : 'play'"></odl-icon>
    </button>
    <odl-tooltip placement="top" [attr.for]="'#' + listenId">{{
      (isSentencePlaying()
        ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
        : 'QUESTIONS.PRONUNCIATION.LISTEN.SENTENCE'
      ) | translate
    }}</odl-tooltip>
    <button
      nrTourAnchor="slow"
      type="button"
      class="sentence-speech__listen sentence-speech__slow"
      [id]="slowId"
      data-speech-item
      [class.playing]="isSlowSentencePlaying()"
      [disabled]="disabled()"
      [attr.tabindex]="activeItemIndex() === slowItemIndex ? 0 : -1"
      [attr.aria-label]="
        (isSlowSentencePlaying()
          ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
          : 'QUESTIONS.PRONUNCIATION.LISTEN.SLOW'
        ) | translate
      "
      (focus)="activeItemIndex.set(slowItemIndex)"
      (click)="toggleSlowSentence()"
    >
      <odl-icon aria-hidden="true" [name]="isSlowSentencePlaying() ? 'pause' : 'turtle'"></odl-icon>
    </button>
    <odl-tooltip placement="top" [attr.for]="'#' + slowId">{{
      (isSlowSentencePlaying()
        ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
        : 'QUESTIONS.PRONUNCIATION.LISTEN.SLOW'
      ) | translate
    }}</odl-tooltip>
  </div>
}
